import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const NavEditorIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M9.94996 17.7L23.34 4.31002C24.11 3.58002 24.11 2.25002 23.34 1.52002L22.48 0.66002C21.71 -0.10998 20.46 -0.10998 19.69 0.66002L6.29996 14.05C6.15996 14.19 6.07996 14.38 6.07996 14.58V17.17C6.07996 17.58 6.41996 17.92 6.82996 17.92H9.41996C9.61996 17.92 9.80996 17.84 9.94996 17.7ZM7.57996 16.42V14.89L20.75 1.72002C20.93 1.54002 21.23 1.54002 21.42 1.72002L22.28 2.58002C22.46 2.76002 22.46 3.07002 22.28 3.25002L9.10996 16.42H7.57996Z"
        fill={color}
      />
      <path
        d="M9.86999 20.7H8.85999C8.51757 20.7 8.23999 20.9776 8.23999 21.32V22.33C8.23999 22.6724 8.51757 22.95 8.85999 22.95H9.86999C10.2124 22.95 10.49 22.6724 10.49 22.33V21.32C10.49 20.9776 10.2124 20.7 9.86999 20.7Z"
        fill={color}
      />
      <path
        d="M19.6999 18.07H18.6899C18.3475 18.07 18.0699 18.3476 18.0699 18.69V19.7C18.0699 20.0424 18.3475 20.32 18.6899 20.32H19.6999C20.0424 20.32 20.3199 20.0424 20.3199 19.7V18.69C20.3199 18.3476 20.0424 18.07 19.6999 18.07Z"
        fill={color}
      />
      <path
        d="M15.3199 21.44H14.3099C13.9675 21.44 13.6899 21.7176 13.6899 22.06V23.07C13.6899 23.4124 13.9675 23.69 14.3099 23.69H15.3199C15.6624 23.69 15.9399 23.4124 15.9399 23.07V22.06C15.9399 21.7176 15.6624 21.44 15.3199 21.44Z"
        fill={color}
      />
      <path
        d="M23.0699 13.69H22.0599C21.7175 13.69 21.4399 13.9676 21.4399 14.31V15.32C21.4399 15.6624 21.7175 15.94 22.0599 15.94H23.0699C23.4124 15.94 23.6899 15.6624 23.6899 15.32V14.31C23.6899 13.9676 23.4124 13.69 23.0699 13.69Z"
        fill={color}
      />
      <path
        d="M22.47 8.73999H21.46C21.1175 8.73999 20.84 9.01757 20.84 9.35999V10.37C20.84 10.7124 21.1175 10.99 21.46 10.99H22.47C22.8124 10.99 23.09 10.7124 23.09 10.37V9.35999C23.09 9.01757 22.8124 8.73999 22.47 8.73999Z"
        fill={color}
      />
      <path
        d="M3.96997 18.44L1.82997 10.44C1.61997 9.66003 1.84997 8.83003 2.40997 8.27003L8.26997 2.41003C8.82997 1.85003 9.65997 1.62003 10.44 1.83003L14.81 3.00003C15.22 3.11003 15.62 2.87003 15.73 2.47003C15.84 2.07003 15.6 1.66003 15.2 1.55003L10.83 0.380026C9.53997 0.0400263 8.14997 0.410026 7.20997 1.35003L1.34997 7.20003C0.409965 8.14003 0.0399653 9.53003 0.379965 10.82L2.52997 18.82C2.69997 19.45 3.02997 20.03 3.49997 20.5C3.78997 20.79 4.26997 20.79 4.55997 20.5C4.84997 20.21 4.84997 19.73 4.55997 19.44C4.27996 19.16 4.07997 18.81 3.97997 18.43L3.96997 18.44Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

NavEditorIcon.displayName = 'NavEditorIcon';
